<template>
  <section :class="['section__information', isValiosaPage ? 'valiosa' : '']">
    <div class="section__information--title">
      <h1>BOOKING INFORMATION</h1>
      <h3>{{ $t('home.Booking Information') }}</h3>
    </div>
    <div class="section__information--car-info">
      <h4>■{{ $t('home.Vehicle Info') }} <span v-if="isExample">{{ $t('home.(Example)') }}</span></h4>
      <h5>{{ reservationInfo.title }}</h5>
      <h6>{{ reservationInfo.subInfo }}</h6>
      <CarInfo :information="reservationInfo.carInfos"></CarInfo>
      <div class="info-detail-area">
        <div class="row-content">
          <div class="title">■{{ $t('home.Lending schedule') }}</div>
          <div class="detail">
            <p class="total-hours">
              {{ reservationInfo.start_at.replace(/-/g, "/") }} ~
              {{ reservationInfo.end_at.replace(/-/g, "/") }}
            </p>
          </div>
        </div>
        <div class="row-content">
          <div class="title">■{{ $t('home.Total Fee') }}</div>
          <div class="detail">
            <p class="total-price">
              ¥{{ addCommas(reservationInfo.totalFee) }}
            </p>
            <hr />
            <dl class="price-detail">
              <dt class="basic-price-title">
                {{ $t('home.basic Fee') }}<br class="sp" />{{ $t('home.(per day)') }}
              </dt>
              <dd class="basic-price">
                ¥{{ addCommas(reservationInfo.carInfos.basicFee) }}
              </dd>
              <div v-for="option in reservationInfo.additionalFees" :key="option.title" class="additional-price">
                <dt class="options-price-title">
                  {{ $t(`home.${option.title}`) }}
                </dt>
                <dd class="options-price">
                  ¥{{ addCommas(option.unitFee) }} x {{ option.quantity }}
                </dd>
              </div>
              <dt
                v-if="
                  reservationInfo.discount
                "
                class="options-price-title"
              >
                {{ $t('home.Coupon Discounts') }}({{ reservationInfo.discount.percentage }}%off)
              </dt>
              <dd
                v-if="
                  reservationInfo.discount
                "
                class="options-price"
              >
                -¥{{
                  addCommas(reservationInfo.discount.price)
                }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="info-detail-area">
        <div class="row-content">
          <div class="title">■{{ $t('home.Customer Info') }}</div>
        </div>
        <div class="row-content">
          <div class="customer-info">
            <dl>
              <dt>{{ $t('home.Name') }}</dt>
              <dd>{{ reservationInfo.customerName }}　様</dd>
              <dt>{{ $t('home.Email') }}</dt>
              <dd>{{ reservationInfo.customerEmail }}</dd>
              <dt>{{ $t('home.Phone number') }}</dt>
              <dd>{{ reservationInfo.customerPhoneNumber }}</dd>
              <dt>{{ $t('home.arrival flight number') }}</dt>
              <dd>{{ reservationInfo.flightNumber }}</dd>
              <dt>{{ $t( 'home.other' ) }}</dt>
              <dd>{{ reservationInfo.other }}</dd>
            </dl>
          </div>
        </div>
      </div>
      <p v-if="isExample">
        {{ $t('home.example of a reservation') }}<br />
        ※{{ $t('home.2,000 yen per hour for extensions not exceeding 10 hours; if extensions exceed 10 hours, a daily basic fee will be added') }}
      </p>
    </div>
  </section>
</template>
<script>
import CarInfo from "/src/components/common/CarInfo";
export default {
  name: "Information",
  components: {
    CarInfo,
  },
  props: {
    reservationInfo: {
      type: Object,
      default: () => ({
        title: "TOYOTA　アルファード",
        subInfo: "沖縄　301 わ　2609",
        start_at: "2023/1/1 10:00",
        end_at: "2023/1/2 18:00",
        totalFee: 41000,
        customerName: "山田太郎",
        customerEmail: "example@class.okinawa",
        customerPhoneNumber: "080-0000-0000",
        flightNumber: "CLS5050",
        other: "baby seat x 1, special requests: hotel pickup",
        additionalFees: [],
        carInfos: {
          main_image: "/images/car-images/main4.png",
          images: [
            "/images/car-images/main1.png",
            "/images/car-images/main2.png",
            "/images/car-images/main3.png",
            "/images/car-images/main4.png",
          ],
          maxmumPassenger: 7,
          isSmokingAllowed: false,
          basicFee: 25000,
        },
      }),
    },
    isExample: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addCommas(num) {
      let str = num.toString();
      let result = "";
      let insertComma = false;

      for (let i = str.length - 1; i >= 0; i--) {
        if (insertComma) {
          result += ",";
          insertComma = false;
        }
        result += str[i];
        if ((str.length - i) % 3 === 0 && i > 0) {
          insertComma = true;
        }
      }
      return result.split("").reverse().join("");
    },
  },
  computed: {
    isValiosaPage() {
      let path = this.$router.currentRoute.value.path;
      return path.includes("valiosa");
    },
  },
};
</script>
<style lang="scss" scoped>
.section__information {
  text-align: center;
  color: var(--color-steelblue);

  &.valiosa {
    color: ar(--color-black);
    .section__information {
      &--title {
        border-bottom: 1.5px solid var(--color-black);
        h1 {
          color: var(--color-black);
        }
        h3 {
          color: var(--color-black);
        }
      }
      &--car-info {
        color: var(--color-black);
      }
    }
    .info-detail-area {
      background-color: #b5b5b5;
    }
  }

  &--title {
    text-align: center;
    margin: 2.3rem;
    border-bottom: 1.5px solid var(--color-steelblue);

    h1 {
      color: var(--color-steelblue);
      letter-spacing: 0.15em;
      font-size: 2rem;
      font-family: var(--font-noto-sans);
      font-optical-sizing: var(--font-default-optical-sizing);
      font-style: var(--font-default-style);

      margin: unset;
    }

    h3 {
      color: var(--color-steelblue);
      letter-spacing: 0.15em;
      font-size: 1rem;
      font-family: var(--font-noto-sans);
      font-optical-sizing: var(--font-default-optical-sizing);
      font-style: var(--font-default-style);
      margin: unset;
      margin-bottom: 0.8rem;
    }
  }

  &--car-info {
    margin-left: auto;
    margin-right: auto;
    width: 34.97rem;
    text-align: left;
    @media screen and (max-width: 430px) {
      width: 20.97rem;
    }
  }

  .info-detail-area {
    border-radius: 2.99px;
    background-color: var(--color-aliceblue);
    min-height: 7.63rem;
    font-size: 0.65rem;
    padding: 1.25rem;
    margin-bottom: 3rem;
    .row-content {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      font-size: 0.8rem;
      letter-spacing: 0.15em;
      .title {
        width: 11rem;
        @media screen and (max-width: 430px) {
          width: 6rem;
        }
      }
      .detail {
        width: 19rem;
        @media screen and (max-width: 430px) {
          width: 14rem;
        }
        .total-price {
          text-align: right;
        }

        hr {
          height: 1px;
          background-color: var(--color-steelblue);
          border: none;
        }
        
        .price-detail {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          dt {
            margin: 0;
            width: 60%;
          }
          dd {
            margin: 0;
            padding-left: 1.5rem;
            width: 40%;
            text-align: right;
          }
          .additional-note {
            font-size: 0.7rem;
            width: 100%;
            .pi {
              font-size: 0.7rem;
            }
          }
          .options-price-help {
            position: absolute;
            cursor: pointer;
            display: flex;
            top: 1.5rem;
            left: 12rem;
            height: 0.7rem;
            font-size: 0.6rem;
            @media screen and (max-width: 430px) {
              top: 2.7rem;
              left: 0rem;
            }
            .options-price-help-icon {
              height: 0.9rem;
            }
          }
          .additional-price {
            display: inline-flex;
            margin: 0;
            width: 100%;
            dt {
              margin: 0;
              width: 60%;
            }
            dd {
              width: 40%;
              padding: initial;
            }
          }
        }
      }
      .customer-info {
        width: 100%;
        dl {
          display: flex;
          flex-wrap: wrap;
          overflow-wrap: break-word;
          text-decoration: none;
          dt,
          dd {
            width: 40%;
            margin-top: 0.1rem;
            @media screen and (max-width: 430px) {
              width: 42%;
            }
          }
        }
      }
    }
  }

  h4 {
    font-size: 1rem;
    letter-spacing: 0.15em;
    font-weight: initial;
    margin: 0rem;
  }
  h5,
  h6 {
    font-size: 0.8rem;
    letter-spacing: 0.15em;
    font-weight: initial;
    margin: 0rem;
  }
}
.sp {
  display: none;
  @media screen and (max-width: 430px) {
    display: block;
  }
}
</style>
